const { default: apiClient } = require("src/apis/api-client");
const { default: apiUrls } = require("src/apis/apis");


const getUser = async (
  dataToSend,
  successCallback = () => {},
  failCallback = () => {}
) => {
  try {
    const { data = {} } = await apiClient.post(
      apiUrls.user.list ,
      dataToSend
    );
    console.log(data, "createUser-success");
    successCallback(data);
  } catch (err) {
    console.log(err, "createUser-error");
    failCallback();
  }
};


const getUserPassword = async (
  dataToSend,
  successCallback = () => {},
  failCallback = () => {}
) => {
  try {
    const { data = {} } = await apiClient.post(apiUrls.users.getUserPassword, dataToSend);
    console.log(data, "login-success");
    successCallback(data);
  } catch (err) {
    console.log(err, "login-error");
    failCallback();
  }
};


export {getUser,getUserPassword};
